<template>
<div class="latest-news">
    <div class="title">
        <h3>Últimas notícias publicadas</h3>
    </div>
    <div class="published-news">
        <div class="news" v-for="(noticia, index) in ultimasFooter" :key="index">
            <a :href="noticia.id">
                <img :src="getFirstActveImage(noticia.imagens)" alt="Imagem">
            </a>
            <div class="news-container">
                <news-header :date="noticia.data_noticia"></news-header>
                <div class="news-text">
                    <div class="news-text">
                        <h3 >
                            {{noticia.titulo}}
                        </h3>
                        <p class="text" v-html="noticia.noticia.substring(0, 500)" v-if="noticia.noticia.length > 0"></p>
                        <a :href="noticia.id" class="leia-mais font-black italic text-black">
                            ...Leia mais
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import newsHeader from './news-header.vue'
import ImagensMixin from '../../../../../mixins/images.mixin'

import axios from 'axios'

export default {
    name: 'latest-news',
    components : {
        newsHeader,
    },
    mixins: [ImagensMixin],
    props: {
        id: String,
    },
    data() {
        return {
            ultimasFooter: [],
        }
    },
    methods: {
        getLastNews(id) {
            axios.get('get-noticia-atual/'+id)
            .then(res => {
                this.ultimasFooter = res.data.ultimasFooter
            })
            .catch(error => console.log(error))
        },
    },
    created() {
        this.getLastNews(parseInt(this.id))
    },
}
</script>

<style lang="scss" scoped>
.latest-news {

    .leia-mais {
        @apply text-black italic font-black;

        &:hover {
            @apply text-secondary;
        }
    }

    .title {
        border-bottom: 3px solid #e6242c;
        h3 {
            @apply font-extrabold text-black uppercase text-xl;
        }
    }
    .published-news {
        @apply flex justify-start py-8 px-0;
        @media (max-width: 768px) {
            @apply flex-col;
        }
        .news {
            @apply px-4;
            width: 100%;
            @media(min-width: 769px) {
                border-right: 1px #e4e4e4 solid;
                width: calc(100% / 4);
            }
            img {
                background: #fed843;
                width: 100%;
                height: 250px;
                border-radius: 10px;
                object-fit: cover;
                object-position: top;
            }
            .news-container {
                p {
                    @apply text-sm;
                }
            }
        }
        .news:first-child {
            @media (max-width: 768px) {
                @apply px-4;
            }
        }
        .news:last-child {
            @apply border-r-0;
            @media (max-width: 768px) {
                @apply px-4;
            }
        }
    }
    a{
        @apply text-black;
    }
    .text {
        @apply text-base;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
}
</style>
